// Resume50.js
import React from 'react';

const Resume50 = ({ color = "#2196f3" }) => {
  return (
    <div
      style={{
        width: '210mm',
        minHeight: '297mm',
        backgroundColor: '#ffffff',
        color: '#333333',
        fontFamily: 'Arial, Helvetica, sans-serif',
        display: 'flex',
        margin: '0 auto',
        boxShadow: '0 4px 25px rgba(0,0,0,0.1)',
        overflow: 'hidden'
      }}
    >
      {/* LEFT SIDEBAR - Dynamic accent color */}
      <div
        style={{
          width: '36%',
          backgroundColor: color,
          color: '#e0e0e0',
          padding: '60px 35px',
          display: 'flex',
          flexDirection: 'column',
          gap: '45px'
        }}
      >
        {/* Circular Photo */}
        <div style={{ alignSelf: 'center', marginBottom: '20px' }}>
          <img
            src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=987&q=80"
            alt="Jennifer Anderson"
            style={{
              width: '170px',
              height: '170px',
              borderRadius: '50%',
              objectFit: 'cover',
              border: `6px solid ${color}`,
              boxShadow: '0 6px 15px rgba(0,0,0,0.3)'
            }}
          />
        </div>

        {/* PROFILE */}
        <div>
          <h3 style={{
            fontSize: '1.3rem',
            fontWeight: 'bold',
            marginBottom: '16px',
            color: '#ffffff',
            textTransform: 'uppercase',
            letterSpacing: '1.5px'
          }}>
            PROFILE
          </h3>
          <p style={{
            fontSize: '0.95rem',
            lineHeight: '1.6',
            color: '#d0d0d0'
          }}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam pharetra in lorem at laoreet. Donec hendrerit libero eget est tempor, quis tempus arcu elementum. In elementum elit at dui tristique feugiat. Mauris convallis, mi at mattis malesuada, neque nulla volutpat dolor.
          </p>
        </div>

        {/* EXPERTISE */}
        <div>
          <h3 style={{
            fontSize: '1.3rem',
            fontWeight: 'bold',
            marginBottom: '16px',
            color: '#ffffff',
            textTransform: 'uppercase',
            letterSpacing: '1.5px'
          }}>
            EXPERTISE
          </h3>
          <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: 0,
            fontSize: '0.98rem',
            lineHeight: '1.8',
            color: '#d0d0d0'
          }}>
            <li>• UI/UX</li>
            <li>• Visual Design</li>
            <li>• Wireframes</li>
            <li>• Storyboards</li>
            <li>• User Flows</li>
          </ul>
        </div>

        {/* REWARD */}
        <div>
          <h3 style={{
            fontSize: '1.3rem',
            fontWeight: 'bold',
            marginBottom: '16px',
            color: '#ffffff',
            textTransform: 'uppercase',
            letterSpacing: '1.5px'
          }}>
            REWARD
          </h3>
          <div style={{ fontSize: '0.95rem', lineHeight: '1.7', color: '#d0d0d0' }}>
            <p><strong>Oct 2019 | Liceria & Co.</strong><br/>The Best Employee of the Year</p>
            <p style={{ marginTop: '16px' }}><strong>May 2017 | Liceria & Co.</strong><br/>The Best Employee of the Year</p>
          </div>
        </div>

      </div>

      {/* RIGHT CONTENT - White background */}
      <div
        style={{
          width: '64%',
          padding: '60px 50px',
          backgroundColor: '#ffffff',
          display: 'flex',
          flexDirection: 'column',
          gap: '50px'
        }}
      >
        {/* Name + Title + Contact */}
        <div>
          <h1 style={{
            fontSize: '2.8rem',
            fontWeight: 'bold',
            margin: '0 0 8px 0',
            color: color,
            lineHeight: '1.05'
          }}>
            Jennifer<br/>Anderson
          </h1>
          <h2 style={{
            fontSize: '1.45rem',
            fontWeight: '600',
            margin: '0 0 20px 0',
            color: color
          }}>
            Art Director
          </h2>

          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '24px',
            fontSize: '1rem',
            color: '#555'
          }}>
            <div>☎ 123-456-7890</div>
            <div>✉ hello@reallygreatsite.com</div>
          </div>
        </div>

        {/* EXPERIENCES */}
        <div>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: 'bold',
            marginBottom: '24px',
            color: color,
            textTransform: 'uppercase',
            letterSpacing: '1.2px'
          }}>
            EXPERIENCES
          </h2>

          <div style={{ marginBottom: '32px' }}>
            <h3 style={{ fontSize: '1.2rem', margin: '0 0 6px 0', color: '#333' }}>
              Company Name | Jan 2022 - Present
            </h3>
            <p style={{ fontSize: '1rem', color: '#555', margin: '0 0 12px 0' }}>
              Job position here
            </p>
            <ul style={{ paddingLeft: '20px', margin: '0', fontSize: '0.97rem', lineHeight: '1.6' }}>
              <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam pharetra in lorem at laoreet. Donec hendrerit libero eget est tempor, quis tempus arcu elementum.</li>
              <li>Mauris convallis, mi at mattis malesuada, neque nulla volutpat dolor.</li>
            </ul>
          </div>

          <div>
            <h3 style={{ fontSize: '1.2rem', margin: '0 0 6px 0', color: '#333' }}>
              Company Name | Jan 2019 - Jan 2022
            </h3>
            <p style={{ fontSize: '1rem', color: '#555', margin: '0 0 12px 0' }}>
              Job position here
            </p>
            <ul style={{ paddingLeft: '20px', margin: '0', fontSize: '0.97rem', lineHeight: '1.6' }}>
              <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam pharetra in lorem at laoreet. Donec hendrerit libero eget est tempor, quis tempus arcu elementum.</li>
            </ul>
          </div>
        </div>

        {/* EDUCATION */}
        <div>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: 'bold',
            marginBottom: '24px',
            color: color,
            textTransform: 'uppercase',
            letterSpacing: '1.2px'
          }}>
            EDUCATION
          </h2>

          <div style={{ marginBottom: '28px' }}>
            <h3 style={{ fontSize: '1.2rem', margin: '0 0 6px 0', color: '#333' }}>
              Enter Your Degree | 2008 - 2012
            </h3>
            <p style={{ fontSize: '1rem', color: '#555', margin: '0 0 8px 0' }}>
              University / College
            </p>
            <ul style={{ paddingLeft: '20px', margin: '0', fontSize: '0.97rem', lineHeight: '1.6' }}>
              <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam pharetra in lorem at laoreet.</li>
            </ul>
          </div>

          <div>
            <h3 style={{ fontSize: '1.2rem', margin: '0 0 6px 0', color: '#333' }}>
              Enter Your Degree | 2008 - 2012
            </h3>
            <p style={{ fontSize: '1rem', color: '#555', margin: '0 0 8px 0' }}>
              University / College
            </p>
            <ul style={{ paddingLeft: '20px', margin: '0', fontSize: '0.97rem', lineHeight: '1.6' }}>
              <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam pharetra in lorem at laoreet.</li>
            </ul>
          </div>
        </div>

     
      </div>
    </div>
  );
};

export const resumeMeta = {
  hasPhoto: true,
  columns: 2,
  colorOptions: [
    { value: "#2196f3", label: "Bright Blue" },
    { value: "#ff5722", label: "Deep Orange" },
    { value: "#4caf50", label: "Forest Green" },
    { value: "#9c27b0", label: "Purple" },
    { value: "#607d8b", label: "Blue Grey" }
  ]
};

export default Resume50;